import Vue from 'vue';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import store from '@/store/store';
import { EventBus } from '@/../util/vue-event-bus';
import { valueUndefined } from '@/../util/validation';

function setInterceptors(instance, auth) {
    instance.interceptors.request.use(
        function(config) {
            EventBus.$emit('loading');
            config.headers.Authorization = store.state.token;
            return config;
        },
        function(error) {
            // Do something with request error
            // return Promise.reject(error);
        },
    );

    instance.interceptors.response.use(
        function(response) {
            EventBus.$emit('loadingEnd');
            // if (valueUndefined(response.data.token) != '') {
            //     store.commit('setTOKEN', response.data.token);
            // }
            return response;
        },
        function(error) {
            EventBus.$emit('loadingEnd');

            if (!error.response) {
                EventBus.$emit('alert', 'error', '네트워크 오류가 발생했습니다.');
                return Promise.reject(error);
            }

            switch (error.response.status) {
                case 400:
                    EventBus.$emit('400', 'error', error.response.data && error.response.data.message);

                    break;
                case 401:
                    location.href = '/';
                    break;
                case 403:
                    alert('등록된 아이피가 아닙니다.');
                    location.href = '/';
                    break;
                case 404:
                    EventBus.$emit('alert', 'error', '정상적인 경로가 아닙니다');
                    break;
                case 500:
                    EventBus.$emit('500', error.response.data && error.response.data.message);

                    break;
                case 503:
                    EventBus.$emit('comingsoon');

                    break;
            }
            return Promise.reject(error);

            // return Promise.reject(error);
        },
    );
    return instance;
}

class axiosClass {
    constructor() {
        this.instarceptor = false;
        this.instance = axios.create({
            baseURL: process.env.VUE_APP_API_URL,
            // headers: {
            //     'Access-Control-Allow-Origin' : '*',
            //     'Access-Control-Allow-Credentials': true,
            // }

        });

        this.instance = setInterceptors(this.instance);

        this.instanceBool = false;
    }

    defaultInstance() {
        this.instance = axios.create({
            baseURL: process.env.VUE_APP_API_URL,
            // headers: {
            //     'Access-Control-Allow-Origin' : '*',
            //     'Access-Control-Allow-Credentials': true,
            // }
        });
        setInterceptors(this.instance);
    }

    fileInstance() {
        this.instance = axios.create({
            baseURL: process.env.VUE_APP_API_URL,
        });
    }

    async ejectInterceptors(ref = '') {
        this.instanceBool = true;
        this.defaultInstance();
        let loading = '';

        this.instance.interceptors.request.use(
            function(config) {
                if (ref != '') {
                    console.log('로딩 창');
                }
                return config;
            },
            function(error) {
                if (ref != '') {
                    console.log('로딩 종료');
                }
                return Promise.reject(error);
            },
        );

        this.instance.interceptors.response.use(
            function(response) {
                return response;
            },
            function(error) {
                return Promise.reject(error);
            },
        );
        return this.instance;
    }

    /**
     * 데이터 가져옴
     * @param {*} url
     * @param {*} params
     * @param {*} interceptor
     */
    get(url, params = {}, interceptor = false) {
        this.defaultInstance();

        let data_params = '';
        for (let i = 0; i < Object.keys(params).length; i++) {
            let key = Object.keys(params)[i];
            let value = params[Object.keys(params)[i]];
            if (data_params == false) {
                data_params += '?' + key + '=' + value;
            } else {
                data_params += '&' + key + '=' + value;
            }
        }

        return this.instance.get(url + data_params, params);
    }

    /**
     * 데이터 SAVE 및 생성
     * @param {*} url
     * @param {*} params
     * @param {*} interceptor
     */
    post(url, params = {}, interceptor = false) {
        this.defaultInstance();
        return this.instance.post(url, params);
    }

    /**
     * 데이터 삭제
     * @param {*} url
     * @param {*} params
     * @param {*} interceptor
     */
    delete(url, params = {}, interceptor = false) {
        this.defaultInstance();

        return this.instance.delete(url, { data: params });
    }

    /**
     * 데이터 수정
     * @param {*} url
     * @param {*} params
     * @param {*} interceptor
     */
    put(url, params = {}, interceptor = false) {
        return this.instance.put(url, params, {});
    }
    /**
     * 파일 업로드 폼데이터 전달
     * @param {*} url
     * @param {*} formData
     */
    file_post(url, formData) {
        this.fileInstance();
        this.instance = setInterceptors(this.instance);
        return this.instance.post(url, formData);
        // console.log(data);
    }
}
export default new axiosClass();
